import { render, staticRenderFns } from "./my_comment_course_plan.vue?vue&type=template&id=4aec482e&scoped=true"
import script from "./my_comment_course_plan.vue?vue&type=script&lang=js"
export * from "./my_comment_course_plan.vue?vue&type=script&lang=js"
import style0 from "./my_comment_course_plan.vue?vue&type=style&index=0&id=4aec482e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aec482e",
  null
  
)

export default component.exports